import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ProgramLocationType} from "../../types/program-location.type";
import {CustomerType} from "../../../customers/angular/types/customer-type.type";
import {AccountModel} from "../../../account/angular/models/account.model";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class ProgramLocationsByTotalValuesTableRowComponent implements IController {

  accountId: string;
  location: any;
  locationIndex: any;
  excludeLocationIds: any;
  onUpdateLocation: Function;
  onDelete: Function;
  onBulkEdit: Function;
  onCreateCustomer: Function;

  public locationTypeToIconMap = {
    ACCOUNT: 'account',
    DEPOT: 'depot',
    CUSTOMER: 'customer',
    AREA: 'service-area'
  }

  public isParentMode: boolean;
  public isExpanded: boolean;
  public accountIds: string[];
  public isDesktop: boolean;
  public quantitySettingsValues: any = {};
  public customerType: typeof CustomerType = CustomerType;

  /* @ngInject */
  constructor(private $filter, private $mdMedia, private confirmDialogService: ConfirmDialogService) {
    this.isDesktop = this.$mdMedia('gt-md');
  }

  $onInit() {
    this._setIsParentMode();
  }

  $onChanges(changes) {
    if (changes.accountId) {
      this.accountIds = this.accountId ? [this.accountId] : [];
    }
    this._setIsParentMode();
  }

  onLocationTypeChange(locationType: ProgramLocationType) {
    this.location.toEntityType = locationType;
    this.updateRequired();
  }

  onLocationAccountSelect(account: AccountModel) {
    this.location.toId = _.get(account, 'id');
    this.location.name = _.get(account, 'name');
    this.updateRequired();
  }

  onLocationDepotSelect(depot) {
    this.location.toId = _.get(depot, 'id');
    this.location.name = _.get(depot, 'name');
    this.updateRequired();
  }

  onLocationCustomerSelect(customer) {
    this.location.toId = _.get(customer, 'id');
    if (customer) {
      if (customer.type === this.customerType.Private) {
        this.location.name = this.$filter('userName')(customer);
      } else {
        this.location.name = customer.businessName
      }
    }
    this.updateRequired();
  }

  onLocationServiceAreaSelect(serviceArea) {
    this.location.toId = _.get(serviceArea, 'id');
    this.location.name = _.get(serviceArea, 'areaName');
    this.updateRequired();
  }

  onLocationChange(updatedLocation) {
    this.location = updatedLocation;
    this.updateRequired();
  }

  onAddVolume() {
    if (!this.location.volumeRangePrices?.length) {
      this.location.volumeRangePrices = [];
    }

    const lastValue = this.location.volumeRangePrices[this.location.volumeRangePrices.length-1];
    this.location.volumeRangePrices.push({
      from: lastValue?.to ? (lastValue.to) : (!lastValue ? 1 : undefined),
      to: lastValue?.to ? (lastValue.to + 1) : (!lastValue ? 2 : undefined),
      value: undefined
    })
    this.updateRequired();
  }

  onAddWeight() {
    if (!this.location.weightRangePrices?.length) {
      this.location.weightRangePrices = [];
    }

    const lastValue = this.location.weightRangePrices[this.location.weightRangePrices.length-1];
    this.location.weightRangePrices.push({
      from: lastValue?.to ? (lastValue.to) : (!lastValue ? 1 : undefined),
      to: lastValue?.to ? (lastValue.to + 1) : (!lastValue ? 2 : undefined),
      value: undefined
    })
    this.updateRequired();
  }

  // edit($event) {
  //   this.onEditLocation({$event: $event, location: this.location});
  // }

  onRemoveVolumeRange(index) {
    this.location.volumeRangePrices.splice(index, 1);
    this.updateRequired();
  }

  onRemoveWeightRange(index) {
    this.location.weightRangePrices.splice(index, 1);
    this.updateRequired();
  }

  onOverrideParentMode(event) {
    this.confirmDialogService.confirm('PROGRAM_OVERRIDE_PARENT_MODE_HEADER', 'PROGRAM_OVERRIDE_PARENT_MODE_DESCRIPTION', event)
      .then(() => {
        this.location.volumeRangePrices = angular.copy(this.location.parentVolumeRangePrices);
        this.location.weightRangePrices = angular.copy(this.location.parentWeightRangePrices);
        this.updateRequired();
      })
  }

  onRevertToParentMode(event) {
    this.confirmDialogService.confirm('PROGRAM_REVERT_TO_PARENT_MODE_HEADER', 'PROGRAM_REVERT_TO_PARENT_MODE_DESCRIPTION', event)
      .then(() => {
        this.location.volumeRangePrices = undefined;
        this.location.weightRangePrices = undefined;
        this.updateRequired();
      })
  }

  private updateRequired() {
    this.onUpdateLocation({location: this.location});
  }

  private _setIsParentMode() {
    this.isParentMode = (!this.location?.volumeRangePrices && !this.location?.weightRangePrices) &&
      (!!this.location?.parentVolumeRangePrices && !!this.location?.parentWeightRangePrices);
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('programLocationsByTotalValuesTableRow', {
    require: {
      form: '^form'
    },
    bindings: {
      accountId: '<?',
      location: '<',
      locationIndex: '<?',
      excludeLocationIds: '<?',
      onUpdateLocation: '&',
      onDelete: '&',
      onBulkEdit: '&',
      onCreateCustomer: '&'
    },
    template: require('./program-locations-by-total-values-table-row.html').default,
    controller: ProgramLocationsByTotalValuesTableRowComponent
  });
